export default __webpack_public_path__ + "static/media/tick-icon-unticked.0f61f156.svg";